import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  CreateFamsSystemChangelogPayload,
  FamsSystemChangelogItem,
  FamsSystemChangelogList,
  FamsSystemChangelogListParams,
  UpdateFamsSystemChangelogPayload,
} from './types/system-changelog';

const request = createAppRequest();

export async function getFamsSystemChangelogList(
  params?: FamsSystemChangelogListParams,
  options?: ApiRequestOptions,
) {
  return request<FamsSystemChangelogList>('/bff/fams/system-changelog', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getLatestFamsSystemChangelog(options?: ApiRequestOptions) {
  return request<FamsSystemChangelogItem | null>('/bff/fams/system-changelog/latest', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function getFamsSystemChangelog(
  uuid: string,
  options?: ApiRequestOptions,
) {
  return request<FamsSystemChangelogItem>(`/bff/fams/system-changelog/${uuid}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function createFamsSystemChangelog(
  payload: CreateFamsSystemChangelogPayload,
  options?: ApiRequestOptions,
) {
  return request<FamsSystemChangelogItem>('/bff/fams/system-changelog', {
    method: 'POST',
    data: payload,
    ...(options || {}),
  });
}

export async function updateFamsSystemChangelog(
  uuid: string,
  payload: UpdateFamsSystemChangelogPayload,
  options?: ApiRequestOptions,
) {
  return request<FamsSystemChangelogItem>(`/bff/fams/system-changelog/${uuid}`, {
    method: 'PUT',
    data: payload,
    ...(options || {}),
  });
}

export async function publishFamsSystemChangelog(
  uuid: string,
  options?: ApiRequestOptions,
) {
  return request<FamsSystemChangelogItem>(
    `/bff/fams/system-changelog/${uuid}/publish`,
    {
      method: 'PATCH',
      ...(options || {}),
    },
  );
}

export async function unpublishFamsSystemChangelog(
  uuid: string,
  options?: ApiRequestOptions,
) {
  return request<FamsSystemChangelogItem>(
    `/bff/fams/system-changelog/${uuid}/unpublish`,
    {
      method: 'PATCH',
      ...(options || {}),
    },
  );
}

export async function deleteFamsSystemChangelog(
  uuid: string,
  options?: ApiRequestOptions,
) {
  return request<{ uuid: string; deleted: boolean }>(
    `/bff/fams/system-changelog/${uuid}`,
    {
      method: 'DELETE',
      ...(options || {}),
    },
  );
}
